import React from 'react';
import _ from 'lodash';

const ThirdStep = props => (
  <section className='simpleSlide active'>
  {props.pedidos.map((pedido, key ) =>
    <div className='form-group' key={key}>
        <div className='card card-plain form-group'>
          <h5 className='card-lg-title'>N° Pedidos</h5>
          <p className='h5'>
          {pedido.numPedidoVeh.map((ped,y)=>
            <span key={ped+y}>{ped}&nbsp;&nbsp;&nbsp;</span>
          )}
          </p>
        </div>
        <p className='labelInfo'>Tipo de solicitud</p>
        {props.maestroGenericoTipoSolicitud.tablaMaestroLogistica.filter(entry => !(entry.codTipo==='03'&&pedido.estadoTransitoFact==='0')).map((row, id) =>
          (
            <div key={id} className='radio'>
                <label className='radio-label'>
                <input
                    id='tipoSolicitud'
                    type='radio'
                    name={'tipoSolicitud' + key}
                    value={row.codTipo}
                    onClick={(event) => props.changeState(event,pedido.codClie,pedido.estadoTransitoFact)}
                    defaultChecked={_.capitalize(props.getCliente(pedido.codClie,pedido.estadoTransitoFact).tipoSolicitud!==null?props.getCliente(pedido.codClie,pedido.estadoTransitoFact).tipoSolicitud:'')===_.capitalize(row.codTipo)}
                />
                <div className='radio-skin' />{row.descripcion}
                </label>
            </div>
          )
        )}

        <div className='form-group'>
          <label className='labelInfo'>Observaciones</label>
          <textarea className='form-control'  id='observaciones'
                onChange={(event) =>props.changeState(event,pedido.codClie,pedido.estadoTransitoFact)}  /><span className='error'>Mensaje de error</span>
        </div>
        <hr />
    </div>

  )}

  <div className='modal-actions'>
        <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
        <button className='btn btn-primary pull-right' onClick={props.nextStep}>Siguiente</button>
  </div>



  </section>
);

export default ThirdStep;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitarFacturacion/ThirdStep.js